// Current individual imports
import { menu } from './components/menu.js';
import { modal } from './components/modal.js';
import { carousel } from './components/carousel.js';
import { tooltip } from './components/tooltip.js';
import { accordion } from './components/accordion.js';
import { collapsible } from './components/collapsible.js';
import { tabs } from './components/tabs.js';
import { overlay } from './components/overlay.js';
import { micromodal } from './components/micromodal.js';
import { input } from './components/input.js';
import { list } from './components/list.js';

export const listOfComponents = {menu,modal,carousel,tooltip,accordion,collapsible,tabs,overlay,micromodal, input, list };
// Export all components

// Future plan: Group related components
// e.g., export { modal, micromodal, fancybox } from './components/modals';
// or use nested imports for better tree-shaking